export const trimSlashes = (str: string) => {
  return str.replace(/^\/+|\/+$/g, '');
};
